import React, { useState } from 'react';

const panelStyle = {
  width: 280,
  background: '#16213e',
  borderLeft: '1px solid #333',
  padding: 16,
  overflowY: 'auto',
  color: '#eee',
  fontFamily: 'sans-serif',
};

const applyBtnStyle = {
  padding: '8px 16px',
  background: '#0f3460',
  color: '#fff',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
  fontSize: 13,
  width: '100%',
  marginTop: 12,
};

const inputStyle = {
  width: 60,
  padding: '4px 6px',
  background: '#1a1a2e',
  color: '#eee',
  border: '1px solid #444',
  borderRadius: 4,
  fontSize: 12,
  textAlign: 'center',
};

const rowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  marginBottom: 6,
};

const labelStyle = {
  fontSize: 11,
  color: '#999',
  width: 60,
};

const DEFAULT_EYE = { center_x: 0, center_y: 0, radius: 20 };

/**
 * RedEyePanel provides inputs for specifying eye regions and a threshold slider.
 *
 * @param {{ editor: object }} props
 */
export default function RedEyePanel({ editor }) {
  const [eyes, setEyes] = useState([{ ...DEFAULT_EYE }, { ...DEFAULT_EYE }]);
  const [eyeCount, setEyeCount] = useState(2);
  const [threshold, setThreshold] = useState(1.5);

  const updateEye = (idx, field, value) => {
    setEyes((prev) => {
      const next = [...prev];
      next[idx] = { ...next[idx], [field]: Number(value) };
      return next;
    });
  };

  const handleApply = () => {
    const regions = eyes.slice(0, eyeCount);
    editor.redEye({ regions, threshold });
  };

  return (
    <div style={panelStyle}>
      <h3 style={{ margin: '0 0 8px', fontSize: 14 }}>Red-Eye Removal</h3>
      <p style={{ fontSize: 11, color: '#888', margin: '0 0 12px' }}>
        Specify eye region coordinates for up to 2 eyes.
      </p>

      {/* Eye count selector */}
      <div style={{ ...rowStyle, marginBottom: 12 }}>
        <span style={labelStyle}>Eyes</span>
        <select
          value={eyeCount}
          onChange={(e) => setEyeCount(Number(e.target.value))}
          style={{ ...inputStyle, width: 50 }}
        >
          <option value={1}>1</option>
          <option value={2}>2</option>
        </select>
      </div>

      {eyes.slice(0, eyeCount).map((eye, idx) => (
        <div key={idx} style={{ marginBottom: 12 }}>
          <div style={{ fontSize: 12, fontWeight: 'bold', color: '#ccc', marginBottom: 6 }}>
            Eye {idx + 1}
          </div>
          <div style={rowStyle}>
            <span style={labelStyle}>Center X</span>
            <input
              type="number"
              value={eye.center_x}
              onChange={(e) => updateEye(idx, 'center_x', e.target.value)}
              style={inputStyle}
            />
          </div>
          <div style={rowStyle}>
            <span style={labelStyle}>Center Y</span>
            <input
              type="number"
              value={eye.center_y}
              onChange={(e) => updateEye(idx, 'center_y', e.target.value)}
              style={inputStyle}
            />
          </div>
          <div style={rowStyle}>
            <span style={labelStyle}>Radius</span>
            <input
              type="number"
              min={1}
              value={eye.radius}
              onChange={(e) => updateEye(idx, 'radius', e.target.value)}
              style={inputStyle}
            />
          </div>
        </div>
      ))}

      {/* Threshold slider */}
      <div style={{ marginBottom: 8 }}>
        <div style={{ fontSize: 12, fontWeight: 'bold', color: '#ccc', marginBottom: 6 }}>
          Threshold
        </div>
        <div style={rowStyle}>
          <input
            type="range"
            min={0.5}
            max={3.0}
            step={0.1}
            value={threshold}
            onChange={(e) => setThreshold(Number(e.target.value))}
            style={{ flex: 1, accentColor: '#0f3460' }}
          />
          <span style={{ fontSize: 11, color: '#ccc', width: 30, textAlign: 'right' }}>
            {threshold.toFixed(1)}
          </span>
        </div>
      </div>

      <button style={applyBtnStyle} onClick={handleApply}>
        Remove Red-Eye
      </button>
    </div>
  );
}
